"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireWildcard(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _DrupalContainerNugget = _interopRequireDefault(require("./DrupalContainerNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalNugget = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/DrupalNugget.js"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _ContainerNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/ContainerNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../../NavigationManagerCordova"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'containerNuggetContainer_';

var DrupalContainerNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalContainerNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalContainerNugget);

  function DrupalContainerNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalContainerNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkForReadNuggets", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var nugget, nuggetsToMark;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_config["default"].setReadToStore) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              nugget = _this.state.content[_this.props.id];

              if (nugget && nugget.contents && nugget.contents.length > 0) {
                nuggetsToMark = [];
                nugget.contents.forEach(function (innerNugget) {
                  var innerNuggetContent = _KESI2Helper["default"].getContentById(innerNugget.id);

                  if (innerNuggetContent) {
                    if (innerNuggetContent.notMandatory || _KESI2BasicComponent.READ_ON_SCROLL_NUGGETS.indexOf(innerNuggetContent["class"]) >= 0) {
                      nuggetsToMark.push(nugget.id);
                    }
                  }
                });

                _this.setState({
                  readNuggets: nuggetsToMark
                }, function () {
                  _this.checkIfAllRead();
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "markNuggetAsRead", function (nuggetId) {
      if (!_config["default"].setReadToStore) {
        return;
      }

      var readNuggets = _this.state.readNuggets;

      if (nuggetId) {
        var index = readNuggets.indexOf(nuggetId);

        if (index < 0) {
          readNuggets.push(nuggetId);
        }
      }

      _this.setState({
        readNuggets: readNuggets
      }, function () {
        _this.checkIfAllRead();
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfAllRead", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var readNuggets, ContainerNugget;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_config["default"].setReadToStore) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              readNuggets = _this.state.readNuggets;
              ContainerNugget = _KESI2Helper["default"].getContentById(_this.props.id);

              if (ContainerNugget && ContainerNugget.contents && ContainerNugget.contents.length > 0) {
                if (readNuggets.length === ContainerNugget.contents.length) {
                  _this.props.markAsRead(_this.props.id);
                }
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function () {
      if (_this.props.onDoneFn) _this.props.onDoneFn();else if (_this.props.goHomeFn) _this.props.goHomeFn();else _NavigationManagerCordova["default"].goBack();
    });
    _this.state = _objectSpread({
      nuggetIndex: 0,
      waitingForActivation: false,
      active: false,
      readNuggets: [],
      isLoading: true
    }, _this.state);
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _ContainerNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalContainerNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalContainerNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.registerNuggetPosition(this.props.id, _ContainerNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      this.setState({
        active: true
      });

      if (_config["default"].setReadToStore) {
        this.checkForReadNuggets();
      }

      var nugget = this.state.content[this.props.id];
      var hasVideoChild = nugget.contents.find(function (child) {
        var nuggetData = _KESI2Helper["default"].getContentById(child.id);

        return nuggetData["class"] === 'video';
      });

      if (!_DeviceInfoHelper["default"].isBrowser() && hasVideoChild) {
        setTimeout(function () {
          _this2.setState({
            isLoading: false
          });
        }, 1000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalContainerNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      /**
       * @type {ContainerNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var hasVideoChild = nugget.contents.find(function (child) {
        var nuggetData = _KESI2Helper["default"].getContentById(child.id);

        return nuggetData["class"] === 'video';
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "galleryContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, hasVideoChild && this.state.isLoading && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalContainerNugget["default"].loadingOverlay
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        className: _DrupalContainerNugget["default"].spinner
      })), /*#__PURE__*/_react["default"].createElement("div", {
        id: "galleryContainer",
        className: "ContainerNugget_".concat(this.props.id, " ").concat(nugget.theme, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ContainerNuggetContainer ".concat(nugget.title && nugget.show_title ? '' : 'extraPadding')
      }, this.state.active && nugget.contents && nugget.contents.length > 0 && nugget.contents.map(function (nuggetToMap, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalContainerNugget["default"].galleryContainer,
          key: nuggetToMap.id
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: "card_".concat(index, "_").concat(_this3.props.id)
        }, /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
          id: nuggetToMap.id,
          path: _this3.props.path,
          registerNugget: _this3.props.registerNugget,
          markAsRead: _this3.markNuggetAsRead,
          contentPathArray: _this3.props.contentPathArray,
          lectureBackgroundColor: _this3.props.lectureBackgroundColor // inGalleryContainer
          // galleryContainerIndex={index}

        })));
      }), nugget.show_close_button && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalContainerNugget["default"].buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: 'contained',
        color: 'white',
        onClick: this.handleClose,
        className: "".concat(_DrupalContainerNugget["default"].closeButton, " btnSubmitButton")
      }, "Fertig")))));
    }
  }]);
  return DrupalContainerNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalContainerNugget;
DrupalContainerNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalContainerNugget.defaultProps = {
  id: null
};